export default {

  getRecoveryData(state) {
    return state.recoveryData
  }
}
